/* Nest & Temple — theme behaviour (no dependencies) */
(function () {
  'use strict';

  /* mobile nav */
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.getElementById('mobile-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* product gallery */
  var main = document.getElementById('gallery-main');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!main) return;
      main.src = btn.dataset.full;
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
        b.setAttribute('aria-selected', String(b === btn));
      });
    });
  });

  /* quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      var next = parseInt(input.value, 10) + parseInt(btn.dataset.qty, 10);
      input.value = Math.max(1, next);
    });
  });

  /* accordions */
  document.querySelectorAll('[data-accordion]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.closest('.accordion__item').classList.toggle('is-open');
    });
  });

  /* scroll reveal (mirrors the framer-motion whileInView behaviour) */
  var revealables = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealables.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (!entry.isIntersecting) return;
        setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 100);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    revealables.forEach(function (el) { io.observe(el); });
  } else {
    revealables.forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
